var finansudd = finansudd || {};

finansudd.menu = new function(){

    var self = this;

    this.triggerMenuHolder = function (selector) {

    	// Selectors
    	var $parent = $('#mobile-menu-wrapper'),
    		$trigger = $('.mobile-menu-trigger'),
    		$menu = $parent.find('.mobile-menu');

    	$trigger.click(function() {
    		$parent.hasClass('active') ? $parent.removeClass('active') :  $parent.addClass('active');

            $('nav.menu-level-1 .menu-item-level-1 ul').removeClass('active');
            $('nav.menu-level-1 .menu-item-level-1 .submenu-trigger').removeClass('active');

            if(!$menu.children().length) {
                self.getAjaxMenu();
            }
    	});

        // TODO: Fix the browser jacking problem on open
        $('#navigation-top').on('click', '.submenu-trigger', function() {

            var $this = $(this),
                $thisParentsSubMenu = $this.parents('.menu-item-level-1').find('.menu-level-2'),
                $thisParentTrigger = $this.parents('.menu-item-level-1').children('.submenu-trigger').first(),
                $submenuTrigger = $('.submenu-trigger'),
                $thisSubMenu = $this.siblings('ul');

            // Toggle the active class
            $this.toggleClass('active');
            $thisSubMenu.toggleClass('active');

            // Reset the other submenu and close them

            $submenuTrigger.not($this).not($thisParentTrigger).removeClass('active');
            $('.menu-level-2').not($thisParentsSubMenu).removeClass('active');

            if($this.parents('nav.menu-level-1').length) {
                $('.mobile-menu-trigger, .mobile-menu ').removeClass('active');

            }
            
        });

	};


    this.getAjaxMenu = function () {
        // Selectors
        var $menuHolder = $('.mobile-menu');

        // Get Ajax content from menu
        $.ajax({
            url: "/settings/ajax-nav/", // TODO: Change this to the right url
            type: 'POST',
            cache: false,
            contentType: "html/text; charset=utf-8",
            dataType: 'html',
            success: function(data) {
                $menuHolder.html(data);
            },
            error: function (data, errorThrown) {
                console.log(errorThrown)
            }
        });

    };

    this.setWidth = function () {
        
        //var width = 0;
        //var $menuItem = $('#navigation-top .menu-item-level-1');

        //if ($menuItem.length) {
        //    $menuItem.each(function () {
        //        width += $(this).outerWidth(true);
        //    });
        //    $menuItem.css('width', width + 100);
        //}
    };



};